<app-dashboard-sidemenu></app-dashboard-sidemenu>

<!-- Start Main Content Wrapper Area -->
<div class="main-content d-flex flex-column">

  <app-dashboard-navbar></app-dashboard-navbar>

  <!-- Breadcrumb Area -->
  <div class="breadcrumb-area" *ngFor="let Content of breadcrumb;">
    <h1>{{Content.title}}</h1>
    <ol class="breadcrumb">
      <li class="item"><a routerLink="/">Home</a></li>
      <li class="item"><a routerLink="/dashboard">{{Content.subTitle}}</a></li>
      <li class="item">{{Content.title}}</li>
    </ol>
  </div>
  <!-- Start -->
  <div class="add-listings-box1">
    <form [formGroup]="toolLoanForm" #toolform="ngForm">
    <div class="row">
      <div class="col-lg-2 col-md-12 form-group">
        <label>Package Number<span class="star_class">*</span></label>
        <input class="form-control" type="text" disabled formControlName="packageNumber" autocomplete="off" />
      </div>

      <div class="col-lg-2 col-md-12 form-group">
        <label>BU<span class="star_class">*</span></label>
        <input class="form-control" type="text" disabled formControlName="bu" placeholder="Enter PO Number"
          autocomplete="off" />
      </div>

      <div class="col-lg-2 col-md-12 form-group">
        <label>Business Unit<span class="star_class">*</span></label>
        <input class="form-control" type="text" disabled  formControlName="businessUnit"
          placeholder="Enter PO Number" autocomplete="off" />
      </div>

      <div class="col-lg-2 col-md-12 form-group">
        <label>Po Type<span class="star_class">*</span></label>
        <input class="form-control" type="text" disabled formControlName="poType"  placeholder="Enter PO Number"
          autocomplete="off" />
      </div>
      <div class="col-lg-2 col-md-12 form-group">
        <label>Po Number<span class="star_class">*</span></label>
        <input class="form-control" type="text" disabled formControlName="orderNumber"
          placeholder="Enter PO Number" autocomplete="off" />
      </div>
      <div class="col-lg-2 col-md-12 form-group">
        <label>Supplier Name<span class="star_class">*</span></label>
        <input class="form-control" type="text" disabled formControlName="supplierName"
          placeholder="Enter PO Number" autocomplete="off" />
      </div>
    </div>

   
      <div class="row">
        <div class="col-lg-3 col-md-12 form-group">
          <label for="Suppplier name">Supplier Authorized Person Name<span class="star_class">*</span></label>
          <input type="text"
          class="form-control"
          formControlName="name"
          placeholder="Enter Name"
          maxlength="25"
         >
        
        <div class="error"
          *ngIf="(formSubmitted  || toolLoanForm.get('name')?.touched) && toolLoanForm.get('name')?.invalid">
          Please enter Name
        </div>
      </div>
        <div class="col-lg-3 col-md-12 form-group">
          <label for="title">title<span class="star_class">*</span></label>
          <input type="input" class="form-control" formControlName="title" placeholder="Enter Title"
            maxlength="25"
            >
          <div class="error"
            *ngIf="formSubmitted && toolLoanForm.get('title')?.invalid || toolLoanForm.get('title')?.touched && toolLoanForm.get('title')?.invalid">
            Please enter Title
          </div>
        </div>
        <div class="col-lg-3 col-md-12 form-group">
          <label for="Date"> Date<span class="star_class">*</span></label>
          <p-calendar formControlName="Date" placeholder="Select Date" [readonlyInput]="true"
            [showIcon]="true"  [minDate]="minDate"></p-calendar>
          <div class="error"
            *ngIf="formSubmitted && toolLoanForm.get('Date')?.invalid || toolLoanForm.get('Date')?.touched && toolLoanForm.get('Date')?.invalid">
            Please enter Date
          </div>
        </div>
        </div>
        <div class="row">
        <div class="col-lg-3 col-md-12 form-group">
          <label for="Guarnatee name">Guarantor Name<span class="star_class">*</span></label>
          <input type="input" class="form-control" formControlName="GuaranteeName" placeholder="Enter Guarantor Name"
            maxlength="25"
            >
          <div class="error"
            *ngIf="formSubmitted && toolLoanForm.get('GuaranteeName')?.invalid || toolLoanForm.get('GuaranteeName')?.touched && toolLoanForm.get('GuaranteeName')?.invalid">
            Please enter Guarantor Name
          </div>
        </div>
        <div class="col-lg-3 col-md-12 form-group">
          <label for="Guarnatee date">Guarnatee Date<span class="star_class">*</span></label>
          <p-calendar formControlName="GuaranteeDate" placeholder="Select Guarnatee Date" [readonlyInput]="true"
            [showIcon]="true"  [minDate]="minDate"></p-calendar>
          <div class="error"
            *ngIf="formSubmitted&& toolLoanForm.get('GuaranteeDate')?.invalid || toolLoanForm.get('GuaranteeDate')?.touched && toolLoanForm.get('GuaranteeDate')?.invalid">
            Please enter Guaarantor Name
          </div>
        </div>
        <div class="col-lg-3 col-md-12 form-group">
          <label for="Subcontractor">Subcontractor Name</label>
          <input type="input" class="form-control" formControlName="sub_name" placeholder="Enter Name"
            maxlength="25">
        </div>
        <div class="col-lg-3 col-md-12 form-group">
          <label for="Subcontractor address">Subcontractor Address</label>
          <input type="input" class="form-control" formControlName="sub_address" placeholder="Enter Address"
            maxlength="25">
        </div>
        <div class="col-lg-12 form-group d-flex align-items-center">
          <input type="checkbox" formControlName="confirmation" id="confirmation" class="mr-2">
          <label for="confirmation" class="mb-0">
            I hereby declare that the provided information is correct.
          </label>
        </div>
        <div class="error"
          *ngIf="formSubmitted&& toolLoanForm.get('confirmation')?.invalid || toolLoanForm.get('confirmation')?.touched && toolLoanForm.get('confirmation')?.invalid">
          You must agree to proceed.
        </div>
      </div>

    </form>
    <div class="card cost-breaker">
        <p-table #dt2 [value]="editsupplierdata?.length ? editsupplierdata : supplierdata" [rows]="10" responsiveLayout="scroll" [showCurrentPageReport]="true"
          [rowsPerPageOptions]="[10,20,30,50]"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

          <ng-template pTemplate="caption">
            <!-- <span class="p-input-icon-left d-flex align-items-center">
                <i class="pi pi-search"></i>
                <input [(ngModel)]="filterval" (input)="dt2.filterGlobal($event.target.value, 'contains')" pInputText
                    type="text" placeholder="Global Search">
                <p-button (click)="reset(dt2)" type="button" class="ml-2" icon="bx bx-reset"></p-button>
            </span> -->
          </ng-template>

          <ng-template pTemplate="header">
            <tr>
              <th>S.No.</th>
              <th>PO No.</th>
              <th>Tool Description</th>
              <th>Item Number</th>
              <th>Tool Type</th>
              <th>Asset Code</th>
              <th>Remarks</th>
              <th>Attach Tool Photos</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-tool let-i="rowIndex">
            <tr>
              <td>{{i+1}}</td>
              <td>{{tool.orderNumber || '-'}}</td>
              <td>{{tool.itemDescription || '-'}}</td>
              <td>{{tool.itemNumber || '-'}}</td>
              <td>{{tool.capital || '-'}}</td>
              <td>{{tool.assetCode || '-'}}</td>
              <td>{{ tool?.remark || '-' }}</td>
              <td style="display: flex; align-items: center; gap: 10px;">
                <input type="file" class="form-control" style="max-width: 50%;"
                  (change)="uploadDoc($event, 'add_doc', i)" />
                <span *ngIf="uploadedFiles[i]">
                  {{ uploadedFiles[i]?.name }}
                </span>
                <img *ngIf="isImageFile(uploadedFiles[i]) && imagePreviews[i]" [src]="imagePreviews[i]" alt="Preview"
                  style="width: 50px; height: 50px; object-fit: cover; border-radius: 5px; border: 1px solid #ccc; cursor: pointer;"
                  (click)="openPreviewDialog(imagePreviews[i])" />
                  <a *ngIf="!isImageFile(uploadedFiles[i]) && imagePreviews[i]" 
                  [href]="imagePreviews[i]" 
                  target="_blank"
                  style="display: inline-flex; align-items: center; gap: 5px; text-decoration: underline;">
                  <i style="font-size: 1.5rem; cursor: pointer;" ></i> View File
               </a>
                <button *ngIf="imagePreviews[i]" (click)="deleteImage(i)" pButton pRipple type="button"
                  icon="bx bx-trash" class="p-button-rounded p-button-danger
                    p-button-text"></button>
                    <div class="error"
                    *ngIf="(formSubmitted || fileTouched[i]) && !uploadedFiles[i]">
                    Please upload Photos.
                  </div>
              </td>
          


            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6">No data found.</td>
            </tr>
          </ng-template>

        </p-table>
       <div class="text-right add-listings-btn">
  <div class="form-group">
    <!-- Submit Button: Show only if supplierdata exists -->
       <button 
      *ngIf="supplierdata && supplierdata.length > 0"
      class="btn btn-primary" 
     [routerLink]="['/toolLoanAgreement']"
      style="margin-right:5px !important;" 
     >
      Back
    </button>
    <button 
      *ngIf="supplierdata && supplierdata.length > 0"
      class="btn btn-primary" 
      (click)="onSubmit()" 
      style="margin-right:5px !important;" 
      [disabled]="isdisabled">
      Submit
    </button>
    
    <!-- Update Button: Show only if supplierdata is empty or undefined -->
    <button 
      *ngIf="!supplierdata || supplierdata.length === 0"
      (click)="updatedoc()" 
      class="btn btn-primary"
      style="margin-right:5px !important;">
      Update
    </button>
  </div>
</div>


    </div>
  </div>
 
</div>
<p-dialog [(visible)]="isDialogVisible" [modal]="true" [closable]="true" header="Image Preview"
[style]="{width: '400px'}">
<img [src]="previewImage" alt="Preview" style="width: 100%; max-height: 400px; object-fit: contain;">
</p-dialog>